
export enum UserProfileType {
  MASTER = 'Master',
  FREE = 'Free',
  BRONZE = 'Bronze',
  PRATA = 'Prata',
  OURO = 'Ouro'
}

export type PatientGroup = 'EMERGENCIA' | 'CRIANCA_GESTANTE' | 'IDOSO_PROBLEMATICO' | 'SADIO_AFETADO';

export type ViewState = 'DASHBOARD' | 'FORM' | 'RESULT' | 'ADMIN' | 'LIBRARY' | 'HISTORY' | 'PATIENTS';

export interface User {
  id: string;
  email: string;
  name: string;
  profile: UserProfileType;
  requestsToday: number;
  lastRequestDate: string; // ISO Date string
  subscriptionExpiry: string | null; // ISO Date string or null for lifetime
  createdAt: string;
}

export interface ColorData {
  cor: string;
  hex: string;
  frequencia: string; 
  onda: string; 
  efeitos: string;
  aplicabilidades: string[];
  contraindicacoes?: string[];
  sinaisDesequilibrio?: {
    excesso: string[];
    falta: string[];
  };
  combinacoes: string[];
  palavrasChave: string[];
}

export interface AgeTimeData {
  min: number;
  max: number;
  tempoBase: string; 
  frequencia: string;
  consideracoes: string;
}

export interface PracticalTreatment {
  "Condição": string;
  "Cores Sugeridas": string;
  "Método/Aplicação": string;
  "Duração/Temporização": string;
  "Observações": string;
}

export interface PatientData {
  nome: string;
  idade: number;
  grupo: PatientGroup;
  sintomasSelecionados: string[];
  sintomasTexto: string;
  dadosBiologicos: string[];
  objetivo: 'TRATAMENTO' | 'PREVENCAO';
}

export interface TreatmentStep {
  fase: 'Inicial' | 'Central' | 'Final';
  descricao: string;
  regiao: string; 
  cor?: string;
  tempo?: string; 
  detalhes: string;
  ideoplastia?: string;
  alerta?: string;
}

export interface TreatmentPlan {
  id: string;
  patientName: string;
  dateCreated: string;
  resumo: string;
  passos: TreatmentStep[];
  frequencia: string;
  consideracoesGerais: string[];
  disclaimer: string;
  generationMethod?: 'AI' | 'Manual';
  // Armazenamos os dados originais para remontar se necessário no histórico
  patientData?: PatientData;
}

export interface MatchResult {
  plan?: TreatmentPlan;
  error?: string;
}
